import { useCallback, useState } from 'react'

export const useModalState = (initialState) => {
	const [open, setOpen] = useState(initialState)
	const openModal = useCallback(() => setOpen(true), [setOpen])
	const closeModal = useCallback(() => setOpen(false), [setOpen])
	const toggleModal = useCallback(() => setOpen((open) => !open), [setOpen])
	return [open, closeModal, toggleModal, openModal]
}